import styled from "styled-components";
import { DefaultButton, PrimaryButton } from "@fluentui/react";

export const ModalContainer = styled.div`
    padding: 2em 1em 1em 2em;
    background: white;
    border-radius: 8px;
`;

export const ModalTitle = styled.h2`
    margin: 0 0 16px 0;
    font-size: 20px;
    font-weight: 600;
    color: #323130;
    cursor: default;
`;

export const TableContainer = styled.div`
    margin: 16px 0 24px 0;
    padding: 0 16px 0 0;
`;

export const Table = styled.table<{$hasMultiplePortfolios?: boolean}>`
    width: 100%;
    border-collapse: collapse;
    
    thead tr
    {
        ${props => props.$hasMultiplePortfolios && `border-bottom: 2px solid white;`}
    }
    
    th
    {
        font-weight: 600;
        padding: 12px 16px;
        border-bottom: 1px solid #e1dfdd;
        background-color: #f8f9fa;
        text-align: left;
        
        &:first-child
        {
            width: 25%;
        }
        
        &:last-child
        {
            width: 75%;
        }
    }
    
    td
    {
        padding: 12px 16px;
        border-bottom: 1px solid #f3f2f1;
    }
`;

export const TableRow = styled.tr<{ $isSelected: boolean }>`
    cursor: pointer;
    transition: background-color 0.2s ease;
    
    &:hover
    {
        background-color: #f8f9fa;
    }
    
    ${props => props.$isSelected && `
        background-color: #deecf9 !important;
        
        &:hover
        {
            background-color: #c7e0f4 !important;
        }
    `}
`;

export const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 16px;
    padding: 0 16px;
`;

export const CloseButton = styled(DefaultButton)`
    background-color: #CC214F !important;
    color: white !important;
    border-color: #CC214F !important;
    min-width: 100px;
    height: 40px;
    
    &:hover
    {
        background-color: #a4262c !important;
        border-color: #a4262c !important;
    }
`;

export const SelectButton = styled(PrimaryButton)`
    min-width: 120px;
    height: 40px;
    
    &:disabled
    {
        background-color: #f3f2f1 !important;
        color: #a19f9d !important;
        border-color: #e1dfdd !important;
    }
`;